import React, { PropTypes } from 'react';

import Tag from '../Tag';

import {
  checkbox,
  container,
  containerColumns,
  item,
  items,
  itemLeftColumn,
  itemMainColumn,
  subheading,
  subheadingDescription,
  tag,
  tagLine,
} from './styles.module.css';

const memberBenefits = [
  {
    title: 'Cancellation Protection',
    body: 'If you need to withdraw due to injury or the race is cancelled we’ll refund your ticket',
  },
  {
    title: 'Best Price Guarantee',
    body: 'If you find this ticket cheaper elsewhere we’ll refund the difference',
  },
  {
    title: 'True Support',
    body: 'We support you 1–1, just get in touch',
  },
];

/**
 * Member Benefits presentational component.
 */
const MemberBenefits = ({ className, columns, description, heading, perks }) => (
  <div className={[columns ? containerColumns : container, className].join(' ')}>
    <h3 className={subheading}>{heading}</h3>
    {description && <p className={subheadingDescription}>{description}</p>}
    {columns && (
      <div className={tagLine}>
        {'All events with'}
        <Tag text="Official Partner" className={tag} />
        {perks ? 'badge are available for perks' : 'events'}
      </div>
    )}
    <div className={items}>
      {memberBenefits.map(({ title, body }) => (
        <div key={title} className={item}>
          <div className={itemLeftColumn}>
            <span className={checkbox} />
          </div>
          <div className={itemMainColumn}>
            <strong>{title}</strong>
            <span>{body}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

MemberBenefits.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.bool,
  description: PropTypes.string,
  heading: PropTypes.string,
  perks: PropTypes.bool,
};

MemberBenefits.defaultProps = {
  className: '',
  columns: false,
  description: undefined,
  heading: 'Why Book Through Let’s Do This?',
  perks: true,
};

export default MemberBenefits;



// WEBPACK FOOTER //
// ./app/src/components/MemberBenefits/component.jsx